function EnrolleeChartGrouping() {
    this.StartDate = new Date();
    this.StopDate = new Date();
    this.EventList = [];
    this.Associations = [];
    this.MatchType = '';
    this.Title = '';
    this.TimelineData = null;
    this.PotentialTrip = false;
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleeChartGrouping;
}